<template>
  <div>
    <b-row class="row toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">系統管理 / 權限角色管理</b-col>
      <b-col>
        <div class="text-right">
          <b-btn class="btn btn-ptc1" v-b-toggle.collapse1>查詢</b-btn>
          <router-link :to="{ name: 'role_management_add', params: { search: search, sName: this.$route.params.sName }}" class="btn btn-normal-ptc1" tag="button" v-if="FunctionPermission > 1">新增</router-link>
        </div>
      </b-col>
    </b-row>
    <div id="func-content">
      <b-card class="mb-2">
        <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px;">
          <fieldset>
            <legend style="font-size: 1rem">資料查詢:</legend>
            <b-form inline>
              <b-input class="mb-2 mr-sm-2 mb-sm-0" id="inlineFormInputName2" placeholder="角色名稱" v-model="sName"/>
              <div>
                <button type="button" class="btn btn-warning text-white" @click="loadRolePerPage(1)">查詢</button>
                <button type="reset" class="btn btn-warning text-white" @click="reset">重設</button>
              </div>
            </b-form>
          </fieldset>
        </b-collapse>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">角色名稱</th>
              <th scope="col">建立時間</th>
              <th scope="col">動作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in roles" :key="item.id">
                <td class="td-middle">{{item.name}}</td>
                <td class="td-middle">{{item.createdAt}}</td>
                <td>
                <router-link v-if="FunctionPermission > 1" :to="{ name: 'role_management_edit', params: { roleId: item.id, roleName: item.name, search: search, sName: sName, isEdit: item.name == '系統管理員'? false: true } }" class="btn-circle btn-circle-ptc1" tag="button"><i class="fas fa-pencil-alt" v-if="item.name != '系統管理員'" title="編輯"></i><i class="fa fa-search-plus" v-if="item.name == '系統管理員'" title="明細"></i></router-link>
                <button class="btn-circle btn-circle-ptc1" @click="showModal('Delete', item.id, item.name)" v-if="FunctionPermission > 1 && item.name != '系統管理員'"><i class="fas fa-trash-alt" title="刪除"></i></button>
                </td>
            </tr>
          </tbody>
        </table>
        <div class="row" style="padding: 0 1rem">
          <b-pagination size="md" :total-rows="search.totalRows" v-model="search.currentPage" :per-page="search.pageRows" @change="loadRolePerPage"></b-pagination>
          <label style="margin:8px">{{search.startRowNum}}到{{search.endRowNum}}，總共 {{search.totalRows}}筆</label>
        </div>
        <b-modal ref="ModalDelete" hide-footer title="權限角色刪除">
                  <div class="d-block text-center" style="margin-bottom: 12px;">
                    確定要刪除角色「{{roleName}}」？
                  </div>
                  <div class="d-block text-right">
                    <b-btn variant="primary" @click="Delete()">確定</b-btn>
                    <b-btn variant="secondary" @click="hideModalDelete">取消</b-btn>
                  </div>
        </b-modal>
      </b-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {API_URL} from '../../store/root.js'
import miniToastr from 'mini-toastr'
// 功能權限function
import {getFunctionPermission} from '../../js/LoginUserFunction.js'

miniToastr.init()

const breadcrumbItems = [
  { text: '系統管理', active: true },
  { text: '權限角色管理', active: true }
]

export default {
  name: 'HelloWorld',
  data () {
    return {
      breadcrumbItems: breadcrumbItems,
      roles: [],
      search: {
        currentPage: 1, // 目前頁(去第幾頁)
        totalRows: 0, // 總筆數
        pageRows: 20, // 一頁幾筆
        startRowNum: 0,
        endRowNum: 0
      },
      sName: '', // 查詢條件
      roleId: '', // 刪除角色 取得roleId
      roleName: '', // 刪除角色 取得roleName
      FunctionPermission: 0 // 功能權限
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F01') // 功能權限 帶入功能代碼
    if (this.FunctionPermission <= 0) {
      this.$router.push({ name: 'name' })
    }
    // 分頁處理 : for 第一次進查詢頁 & 從編輯頁跳回來時
    this.sName = this.$route.params.sName
    var search = this.$route.params.search
    if (search !== undefined) {
      this.search = search
      this.loadRolePerPage(this.search.currentPage)
    } else {
      this.loadRolePerPage(1)
    }
  },
  methods: {
    reset () {
      this.sName = ''
      this.search.currentPage = 1
      this.loadRolePerPage(1)
    },
    loadRolePerPage: function (currentPage) {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/roles/list', {
        Name: this.sName,
        ToPage: currentPage,
        PerPage: this.search.pageRows
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.roles = response.data.data
            this.search.totalRows = (response.data.totalRows === undefined) ? 0 : response.data.totalRows
            this.search.currentPage = response.data.pageNumber // 分頁處理 : 從編輯頁回列表時，跳回目前分頁
            this.search.startRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : this.search.pageRows * (this.search.currentPage - 1) + 1
            this.search.endRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : (this.search.pageRows > response.data.totalRows) ? response.data.totalRows : (this.search.currentPage * this.search.pageRows) >= response.data.totalRows ? response.data.totalRows : this.search.currentPage * this.search.pageRows
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
            }
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    showModal (mode, id, name) {
      if (mode === 'Delete') {
        this.$refs.ModalDelete.show()
      }
      this.roleId = id
      this.roleName = name
    },
    hideModalDelete () {
      this.$refs.ModalDelete.hide()
    },
    Delete () {
      this.hideModalDelete()
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/roles/delete', {
        roleID: this.roleId
      })
        .then((response) => {
          if (response.data.result === '0000') {
            miniToastr.success('刪除角色成功')
            this.loadRolePerPage(this.currentPage)
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
            }
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/pages/system/roleManagement.vue